export const myHrTitle = 'HR';
